// Asisten Nomor Pesanan mockup (Owner/Admin): saklar + riwayat. Hanya indikator; tidak menahan upload. Default OFF.
import { useCallback, useEffect, useState } from "react";
import axios from "axios";
import { ShieldCheck, RefreshCw, AlertTriangle } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api/order-no-check`;
const BE = process.env.REACT_APP_BACKEND_URL;
const ax = (cfg) => axios({ withCredentials: true, ...cfg });
const errMsg = (e) => { const d = e?.response?.data?.detail; return typeof d === "string" ? d : (e?.message || "Gagal"); };
const STATUS = { cocok: ["COCOK", "#15803d"], berbeda: ["BERBEDA", "#b45309"], perlu_pemeriksaan: ["PERLU PEMERIKSAAN", "#b45309"], dilewati: ["Dilewati", "#64748b"] };
const fileUrl = (r) => r.file_id ? `${BE}/api/${r.source === "offline" ? "" : "shopee/"}files/${r.file_id}/preview` : "";

function Settings({ s, isOwner, busy, onSave }) {
  return <div className="card" style={{ padding: 12, display: "grid", gap: 8 }} data-testid="onc-settings-card">
    <div style={{ display: "flex", gap: 10, alignItems: "center", flexWrap: "wrap" }}>
      <b>Validasi nomor (OCR lokal):</b>
      <span data-testid="onc-enabled-state" style={{ fontWeight: 700, color: s.enabled ? "#15803d" : "#b91c1c" }}>{s.enabled ? "ON" : "OFF"}</span>
      {isOwner && <button className={s.enabled ? "soft-btn small-btn" : "primary small-btn"} disabled={busy} data-testid="onc-toggle-btn"
        onClick={() => onSave({ enabled: !s.enabled, gemini_assist: false })}>{s.enabled ? "Matikan" : "Aktifkan"}</button>}
    </div>
    <div style={{ display: "flex", gap: 10, alignItems: "center", flexWrap: "wrap" }}>
      <b>Bantuan Gemini (potongan area nomor):</b>
      <span data-testid="onc-gemini-state" style={{ fontWeight: 700, color: s.gemini_assist ? "#15803d" : "#b91c1c" }}>{s.gemini_assist ? "ON" : "OFF"}</span>
      {isOwner && s.enabled && <button className="soft-btn small-btn" disabled={busy} data-testid="onc-gemini-toggle-btn"
        onClick={() => onSave({ enabled: true, gemini_assist: !s.gemini_assist })}>{s.gemini_assist ? "Matikan Gemini" : "Aktifkan Gemini"}</button>}
    </div>
    {s.updated_by && <small style={{ color: "#64748b" }}>Terakhir diubah {s.updated_by}</small>}
  </div>;
}

function Row({ r }) {
  const [lab, color] = STATUS[r.status] || [r.status, "#334155"];
  const g = r.gemini_hint;
  return <tr data-testid={`onc-row-${r.id}`}>
    <td><small>{new Date(r.created_at).toLocaleString("id-ID")}</small><br/><small>{r.channel} · {r.uploader_name || "-"}</small></td>
    <td><b>{r.expected}</b><br/><small>Terbaca: {(r.detected || []).join(", ") || "-"}</small></td>
    <td><span style={{ color, fontWeight: 700 }} data-testid={`onc-row-status-${r.id}`}>{lab}</span>
      {r.reason && <><br/><small>{r.reason}</small></>}
      {g && <><br/><small data-testid={`onc-row-gemini-${r.id}`}>Gemini: {g.status === "done" ? `${(g.lines || []).join(" | ") || "-"} (${g.matches_expected ? "menyebut nomor sistem" : "tidak menyebut nomor sistem"})` : g.reason}</small></>}</td>
    <td>{fileUrl(r) ? <a href={fileUrl(r)} target="_blank" rel="noreferrer" data-testid={`onc-row-file-${r.id}`}>Lihat file</a> : <small>tidak disimpan</small>}</td>
    <td><small data-testid={`onc-row-ack-${r.id}`}>{r.acknowledged ? `Sudah diperiksa · ${r.acknowledged.by}` : (r.status === "cocok" || r.status === "dilewati" ? "-" : "Belum ditandai")}</small></td>
  </tr>;
}

export default function OrderNoCheckPanel({ isOwner }) {
  const [s, setS] = useState(null);
  const [data, setData] = useState({ rows: [], total: 0 });
  const [onlyWarn, setOnlyWarn] = useState(false);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const load = useCallback(async () => {
    setErr("");
    try {
      const [a, b] = await Promise.all([ax({ url: `${API}/settings` }), ax({ url: `${API}/checks`, params: { limit: 100 } })]);
      setS(a.data); setData(b.data);
    } catch (e) { setErr(errMsg(e)); }
  }, []);
  useEffect(() => { load(); }, [load]);
  const save = async (body) => {
    setBusy(true);
    try { setS((await ax({ method: "put", url: `${API}/settings`, data: body })).data); } catch (e) { setErr(errMsg(e)); } finally { setBusy(false); }
  };
  const rows = onlyWarn ? data.rows.filter(r => r.status === "berbeda" || r.status === "perlu_pemeriksaan") : data.rows;
  return <div style={{ display: "grid", gap: 12 }} data-testid="onc-panel">
    <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
      <ShieldCheck size={18}/><h2 style={{ margin: 0, fontSize: 18 }}>Asisten Nomor Pesanan Mockup</h2>
      <button className="soft-btn small-btn" onClick={load} data-testid="onc-refresh-btn"><RefreshCw size={13}/> Muat ulang</button>
    </div>
    <div className="card" style={{ padding: 10, fontSize: 13, background: "#f8fafc" }} data-testid="onc-disclaimer">
      Asisten pemeriksa untuk desainer: nomor di gambar dibaca OCR lokal dan dicocokkan persis (hanya spasi & huruf besar/kecil diabaikan).
      Cocok → indikator hijau. Berbeda / tidak terbaca → peringatan kuning + tombol "Sudah Diperiksa". Upload TIDAK pernah ditolak; keputusan akhir pada desainer. Gemini hanya petunjuk.
    </div>
    {err && <div className="card" style={{ padding: 10, color: "#b91c1c" }} data-testid="onc-error"><AlertTriangle size={14}/> {err}</div>}
    {s && <Settings s={s} isOwner={isOwner} busy={busy} onSave={save} />}
    <label style={{ fontSize: 13 }}><input type="checkbox" checked={onlyWarn} onChange={e => setOnlyWarn(e.target.checked)} data-testid="onc-only-warn"/> Hanya peringatan</label>
    <div className="card" style={{ padding: 0, overflowX: "auto" }}>
      <table className="table" style={{ width: "100%" }} data-testid="onc-table">
        <thead><tr><th>Waktu</th><th>Nomor sistem</th><th>Hasil</th><th>File</th><th>Desainer</th></tr></thead>
        <tbody>{rows.length ? rows.map(r => <Row key={r.id} r={r} />) : <tr><td colSpan={5} data-testid="onc-empty">Belum ada data.</td></tr>}</tbody>
      </table>
    </div>
    <small style={{ color: "#64748b" }} data-testid="onc-total">Total {data.total}</small>
  </div>;
}
